import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider, useApp } from "@/context/AppContext";
import { Header } from "@/components/Header";
import { AIChat } from "@/components/AIChat";
import PwaInstallPrompt from "@/components/PwaInstallPrompt";
import Landing from "@/pages/Landing";
import Calculator from "@/pages/Calculator";
import Dashboard from "@/pages/Dashboard";
import Marketplace from "@/pages/Marketplace";
import Education from "@/pages/Education";
import Grants from "@/pages/Grants";
import Investment from "@/pages/Investment";
import Coach from "@/pages/Coach";
import Onboarding from "@/pages/Onboarding";
import Weather from "@/pages/Weather";
import Compare from "@/pages/Compare";
import Community from "@/pages/Community";
import Referral from "@/pages/Referral";
import Pricing from "@/pages/Pricing";
import { PaymentSuccess, PaymentCancel, PayPalReturn } from "@/pages/Payment";
import { Login, Register } from "@/pages/Auth";

const Protected = ({ children }) => {
  const { user, loading } = useApp();
  if (loading) return <div className="p-12 text-center text-[#6E7A71]">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function AppShell() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/calculator" element={<Calculator />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/education" element={<Education />} />
        <Route path="/grants" element={<Grants />} />
        <Route path="/investment" element={<Investment />} />
        <Route path="/coach" element={<Coach />} />
        <Route path="/weather" element={<Weather />} />
        <Route path="/compare" element={<Protected><Compare /></Protected>} />
        <Route path="/community" element={<Community />} />
        <Route path="/referral" element={<Protected><Referral /></Protected>} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/paypal-return" element={<PayPalReturn />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
        <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <AIChat />
      <PwaInstallPrompt />
      <Toaster richColors position="top-right" />
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </AppProvider>
  );
}
